import { render, staticRenderFns } from "./UpdateTeamMembership.vue?vue&type=template&id=3123bdf7&scoped=true"
import script from "./UpdateTeamMembership.vue?vue&type=script&lang=js"
export * from "./UpdateTeamMembership.vue?vue&type=script&lang=js"
import style0 from "./UpdateTeamMembership.vue?vue&type=style&index=0&id=3123bdf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3123bdf7",
  null
  
)

export default component.exports